import React from 'react';

import { SimpleCallback } from '../../../typings';
import { Button } from '../../button/button';
import Text from '../../text/text';

import './quiz-list__more-button.scss';

interface Props {
    onClick: SimpleCallback;
}

export const QuizListMoreButton = (props: Props) => {
    const { onClick } = props;

    return (
        <Button className="quiz-list__more-button" onClick={onClick} view={Button.VIEW.SECONDARY}>
            <Text id="quiz.list.moreButtonText" />
        </Button>
    );
};
